import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import { CButton } from '@coreui/react-pro'
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from '../../components/details/expense-details/AppDetails'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview'

// helpers
import Axios from 'src/helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const ExpenseDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params
  const { showError } = useToastMessage();

  const [expenseDetails, setExpenseDetails] = useState('')

  const [openFilePreview, setOpenFilePreview] = useState(false)

  const handleCardHeaderButton = () => {
    navigate(`/expense/edit/${id}`)
  }

  useEffect(() => {
    fetchExpenseDetails()
  }, [id]);

  const fetchExpenseDetails = () => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/expense/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setExpenseDetails(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      <div className='d-grid gap-2 d-md-flex justify-content-md-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/expense/list')}>
          Back
        </CButton>
      </div>
      <AppCard
        className='mt-4 mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Expense Details</h4>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
          />
        }
        bodyContent={
          <AppDetails
            expenseDetails={expenseDetails}
            handleViewFile={setOpenFilePreview}
          />
        }
      />
    </>
  )
}

export default ExpenseDetails
